import React from 'react';
import { IconWrapper, HelpIconWrapper, HelpContent } from './index.styles'
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepButton from '@material-ui/core/StepButton';
import CheckCircle from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import HelpIcon from '@material-ui/icons/Help';
import Popover from 'components/popover';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    position: 'sticky',
    top: '0',
    '& .MuiStepper-root': {
      width: '65px',
      padding: '10px 0',
      background: 'transparent',
    },
    '& .MuiStepButton-root.with-status .MuiStepLabel-iconContainer': {
      display: 'none',
    },
    '& .MuiStepLabel-root': {
      flexDirection: 'column',
      width: '65px',
    },
    '& .MuiStepLabel-iconContainer': {
      paddingRight: 0,
    },
    '& .MuiStepConnector-vertical': {
      marginLeft: '31px',
    },
    '& .MuiStepLabel-label': {
      margin: '8px 0',
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: '16px',
      color: '#000',
    },
  },
}));

const StepIcon = ({ status }: { status: string }) => {
  return (
    <IconWrapper status={status}>
      {status === 'APPROVED' && <CheckCircle />}
      {status === 'REJECTED' && <CancelIcon />}
      {status === 'SKIPPED' && <HelpIcon />}
    </IconWrapper>
  );
};

const Steps: React.FC<{
  activeStep: number;
  isSkipped?: (step: number) => boolean;
  steps: string[];
  handleStep: (index: number) => void;
  statuses?: string[];
}> = ({ activeStep, isSkipped, steps, handleStep, statuses }) => {
  const classes = useStyles();

  const stepsInfo = [
      'Confirm that their personal info is correct and that it matches their submitted KTP',
      'Confirm that the selfie matches what’s on the submitted KTP. If unable to validate KTP with Iluma, please use alternate routes to verify if unable to retry',
      'Confirm the final decision given Iluma CFT and PEP individual checks for this customer. If score appears and is below 80, kindly consult product team',
  ];

  const renderButton = (
    index: number,
    label: string,
    handleStep: (index: number) => void,
  ) => {
    return statuses?.map((itemStatus, idx) => {
      if (idx === index) {
        if (itemStatus === 'PENDING') {
          return (
            <StepButton onClick={() => handleStep(index)}>
              <StepLabel>
                <Popover
                  anchorOriginHorizontal="left"
                  anchorOriginVertical="center"
                  transformOriginHorizontal="left"
                  transformOriginVertical="center"
                  anchor={
                    <HelpIconWrapper>
                      <HelpIcon />
                    </HelpIconWrapper>
                  }
                >
                  {() => <HelpContent>{stepsInfo[index]}</HelpContent>}
                </Popover>
                {label}
              </StepLabel>
            </StepButton>
          );
        }
        return (
            <StepButton
                className="with-status"
                onClick={() => handleStep(index)}
            >
              <StepLabel>
                <StepIcon status={itemStatus}></StepIcon>
                <Popover
                    anchorOriginHorizontal="left"
                    anchorOriginVertical="center"
                    transformOriginHorizontal="left"
                    transformOriginVertical="center"
                    anchor={
                      <HelpIconWrapper>
                        <HelpIcon />
                      </HelpIconWrapper>
                    }
                >
                  {() => <HelpContent>{stepsInfo[index]}</HelpContent>}
                </Popover>
                {label}
              </StepLabel>
            </StepButton>
        );
      } else {
        return null;
      }
    });
  };

  return (
    <div className={classes.root}>
      <Stepper nonLinear activeStep={activeStep} orientation="vertical">
        {steps.map((label, index) => {
          return (
            <Step key={label}>
              {index === activeStep || index > 2 ? (
                <StepButton onClick={() => handleStep(index)}>
                  <StepLabel>
                    <Popover
                      anchorOriginHorizontal="left"
                      anchorOriginVertical="center"
                      transformOriginHorizontal="left"
                      transformOriginVertical="center"
                      anchor={
                        <HelpIconWrapper>
                          <HelpIcon />
                        </HelpIconWrapper>
                      }
                    >
                      {() => <HelpContent>{stepsInfo[index]}</HelpContent>}
                    </Popover>
                    {label}
                  </StepLabel>
                </StepButton>
              ) : (
                renderButton(index, label, handleStep)
              )}
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
};

export default Steps;
